import React from 'react';
function CommonDialog({ onCancel, onConfirm, dialogText, headerText, cancelText, confirmText }) {
    return (
        <>
            <dialog
                id='delete_dialog2'
                className='bottom-0 fixed flex h-full inset-x-0 px-4 sm:inset-0 sm:items-center sm:justify-center w-full z-40'
                open
            >
                <span
                    className='!w-[483px] bg-white overflow-hidden pl-[50px] pr-[25px] pt-[52px] py-[48px] relative rounded'
                    style={{ boxShadow: '0 4px 14px #0003' }}
                >
                    <img
                        src='/images/exit.ca93bf87.svg'
                        alt='Exit Logo'
                        onClick={onCancel}
                        className='!cursor-pointer absolute h-[14px] right-[25px] top-[25px] w-[14px]'
                    />
                    {headerText && (
                        <span className='flex gap-[10px] items-center mb-[16px]'>
                            <h1 className='font-[700] font-montserrat text-left text-xl'>
                                {headerText}
                            </h1>
                        </span>
                    )}
                    <span className='!font-[400] font-open-sans text-base text-gray-800 text-left'>
                        <p className='max-w-[380px]'>{dialogText}</p>
                        <span className='flex gap-[28px] items-end justify-end mt-[32px]'>
                            {cancelText && (
                                <button
                                    id='close-button'
                                    tabIndex='0'
                                    className='!btn__tertiary !flex !items-center !justify-center !py-[9px] !text-secondary-red !w-[83px]'
                                    aria-label='Close'
                                    type='button'
                                    onClick={onCancel}
                                >
                                    {cancelText}
                                </button>
                            )}

                            <button
                                id='delete-button'
                                tabIndex='0'
                                className='!bg-primary-yellow !btn__primary !flex !h-[40px] !hover:bg-primary-yellow-100 !items-center !justify-center !px-[16px] !text-black !w-fit'
                                aria-label='Close'
                                type='button'
                                onClick={onConfirm}
                            >
                                {confirmText}
                            </button>
                        </span>
                    </span>
                </span>
            </dialog>
        </>
    );
}

export default React.memo(CommonDialog);
